@import (reference) '../../../../../../constants/spacing.module.less';

.additional-items-banner {
  margin: @space-0 @space-16 @space-16;
}
